const obj = {
  id: '',
  description: '',
  zebraCode: '',
}

export default function ZebraTagModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
};
